/**
 * Static copy for a policy term's automatic-renewal limit.
 */
export const POLICY_TERM_AUTO_RENEW_CONFIG = {
  maxAutoRenewals: {
    label: 'Maximum automatic renewals',
    description:
      'Leave blank for unlimited, or enter 0 to stop automatic renewals. Renewals customers start themselves are not limited and start the count over.',
    placeholder: 'Unlimited',
    min: 'Maximum automatic renewals must be 0 or higher.',
    wholeNumber: 'Maximum automatic renewals must be a whole number.',
  },
  details: {
    header: 'Max Auto-Renewals',
    unlimited: 'Unlimited',
    notApplicable: '—',
  },
} as const;
